<div class="commentary">
  <div class="image-container">
    <img
      class="avatar"
      [src]="userService.userContactLogo"
      alt="profile_photo"
      onerror="src='assets/icons/user-profile.svg'"
    />
  </div>
  <div class="commentary-content">
    <div class="commentary-header">
      <p class="text-head text-cut" [title]="commentary.UserFullName">
        {{ commentary.UserFullName }}
      </p>
      <p
        class="text-xs text-sub"
        [title]="commentary.DateTimeComment | momentPipe : 'DD.MM.YYYY HH:mm A'"
      >
        {{ commentary.DateTimeComment | momentPipe : "MM DD YYYY" }}
      </p>
    </div>
    <p
      [title]="commentary.Comment"
      class="text-body text-cut text-line-clamp-2"
    >
      {{ commentary.Comment }}
    </p>
  </div>
</div>
